<template>
  <div class="entry">
    <div class="sidebar" :class="{ slideOut: isSlideOut }">
      <div class="entry-item" @click="handleContact">
        <img class="entry-item-img" src="../../assets/images/client/earphone.png" alt="" />
      </div>
      <div class="entry-item" @click="openDialog">
        <img class="entry-item-img" src="../../assets/images/client/text.png" alt="" />
      </div>
      <div class="entry-item qrcode">
        <el-popover
          placement="left"
          popper-class="qrcode"
          trigger="hover">
          <img class="qrcode-img" src="../../assets/images/client/qrcode.jpg" alt="">
          <img slot="reference" class="entry-item-img" src="../../assets/images/client/weixin.png" alt="" />
        </el-popover>
      </div>
      <div class="entry-item" @click="backTop">
        <img class="entry-item-img" src="../../assets/images/client/top_line.png" alt="" />
      </div>
    </div>

    <!-- 弹出框 -->
    <el-dialog class="dialog width-500 v2-dialog" title="建议和反馈问题" :visible.sync="dialogVisible" :before-close="beforeClose">
      <!-- 表单 -->
      <div class="detail-form">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :pull="1">
              <el-form-item label="选择产品：" :label-width="formLabelWidth">
                <el-select class="select-300" v-model="addForm.productionId"> 
                  <el-option v-for="item in productList" :key="item._id" :value="item._id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :pull="1">
              <el-form-item label="问题建议：" :label-width="formLabelWidth" prop="contents">
                <el-input class="input-300" :rows='4' type="textarea" placeholder="请简要描述问题或建议" v-model="addForm.contents"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
          <el-col :pull="1">
            <el-form-item label="上传图片：" :label-width="formLabelWidth">
              <el-upload
                ref="upload"
                :action="actionUrl"
                type="drag"
                class="client-upload"
                :limit='limitCount'
                :class="{hidePic:hideUpload}"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-change="handleChange"
                :on-success="handleSuccess"
                accept=".jpg,.png,.jpeg,.PNG,.gif"
                :auto-upload="false"
                :file-list="fileList"
                :on-remove="handleRemove">
                <div class="upload_icon">
                  <img src="../../assets/images/client/upload_img.png" alt="">
                  <span>大小在2M以内</span>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          </el-row>
          <div class="form-footer">
            <el-button class="customStyle" :loading="submitEditLoading" type="primary" @click="submitEdit('addForm')">提 交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog class="dialog v2-dialog" :visible.sync="previewDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations ,mapState } from 'vuex';
export default {
  data() {
    return {
      dialogVisible: false,
      addForm:{
        "category":"",   //产品端  B端:"2B" C端:"2C"
        "productionId":"", //关联的产品类型
        "phone":"",   //电话
        "userName":"",  //用户名
        "contents":"",  //反馈内容
        "imgUrl":""   //图片url
      },//新增/编辑入参
      rules: {
        contents: [
          { required: true, message: '请输入问题建议', trigger: 'blur' },
        ]
      },
      submitEditLoading: false,//提交按钮loading
      formLabelWidth: '100px',
      fileList: [],//上传文件列表
      actionUrl:'',//表单图片上传地址
      productList:[],//产品列表,
      isSlideOut: false, // 侧边栏是否滑出的标志位
      dialogImageUrl: '',//图片预览地址
      previewDialogVisible: false,//图片预览
      hideUpload: false,//是否存在待上传图片图片
      limitCount:1,//上传图片数量
    };
  },
  created() {
    this.getProductionClientInfo();//获取产品列表
    // 获取要上传的地址
    this.getUploadAddress({ type: 'img'}).then(data=>{
      this.actionUrl = data.uploadAddress;
    })
  },
  watch: {
    profile: {
      handler: function (val) {
        if(val) this.initContact();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      currentClient: state=>state.User.currentClient,
      profile: state=>state.User.profile
    })
  },
  methods: {
    ...mapActions(['productionClientInfo', 'feedbackAdd', 'getUploadAddress']),
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.previewDialogVisible = true;
    },
    backTop(){
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // 使用平滑滚动效果
      });
    },
    // 侧边栏滑出动画
    handleScroll(){
      const scrollTop = window.pageYOffset; // 更新当前页面滚动的距离
      if (scrollTop > 68) {
        this.isSlideOut = true;
      } else {
        this.isSlideOut = false;
      }
    },
    handleContact(){
      window.qimoChatClick();
    },
    // 打开弹出框
    openDialog(){
      this.dialogVisible = true;
      // 默认选中第一个产品
      if(this.productList && this.productList.length > 0){
        this.addForm.productionId = this.productList[0]._id;
      }
    },
    // 弹出框关闭之前，重置表单
    beforeClose(done) {
      this.initForm();
      this.$refs.addForm.resetFields();
      done();
    },
    // 初始化表单数据
    initForm(){
      this.addForm = {
        "category":"",   //产品端  B端:"2B" C端:"2C"
        "productionId":"", //关联的产品类型
        "phone":"",   //电话
        "userName":"",  //用户名
        "contents":"",  //反馈内容
        "imgUrl":""   //图片url
      }//新增/编辑入参
      this.fileList = [];
      this.hideUpload = false;
    },
    // 提交按钮
    submitEdit(formName){
      // 自定义上传方法
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.hideUpload){
            this.$refs.upload.submit();
          }else{
            this.uploadForm();
          }
        }
      });
    },
    // 上传图片成功
    handleSuccess(res, file){
      if(res.code === 0 && res.data && res.data.url){
        const { url } = res.data
        this.addForm.imgUrl = url;

        // 图片上传成功后，上传表单
       this.uploadForm();
      }else{
        this.handleRemove();
        this.$message.error(res.message);
      }
    },
    // 提交表单
    uploadForm(){
      this.submitEditLoading = true;
      // 编辑、新增接口
      const params = { 
        ...this.addForm,
        category: this.currentClient
      }
      if(this.profile && this.profile.userName){
        params.userName = this.profile.userName
      }
      this.feedbackAdd(params).then(res=> {
        this.$message.success('提交成功');
        this.submitEditLoading = false;
        this.dialogVisible = false;
        this.initForm();
      }).finally(()=> {
        this.submitEditLoading = false;
      });
    },
    // 移除文件
    handleRemove (file, fileList) {
      this.hideUpload = fileList.length > 0;
      this.fileList = [];
      this.addForm.imgUrl = '';
      this.addForm.longImgUrl = '';
      this.$refs.upload.clearFiles();//清空文件列表
    },
    // 上传文件发生变化
    handleChange (file, fileList) {
      const imgType = [
        'image/jpg',
        'image/jpeg',
        'image/png',
        'image/PNG',
        'image/gif'
      ]
      const isImg = imgType.indexOf(file.raw.type) > -1;
      const size = file.size / 1024 / 1024 <= 2;
      if (!isImg) {
        this.$message.error("仅支持上传jpg、jpeg、png、gif格式图片");
        this.fileList = [];
        this.hideUpload = false;
        return
      }
      if (!size) {
        this.$message.error("仅支持上传≤2M的图片");
        this.fileList = [];
        this.hideUpload = false;
        return
      }
      this.hideUpload = fileList.length > 0;//是否显示上传按钮
    },
    // 获取产品列表
    getProductionClientInfo(){
      this.productionClientInfo({
        "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
      }).then(list => {
        this.productList = list;
      })
    },
    initContact(){
      let className = 'client-b';
      let otherClassName = 'client-b';
      let scriptSrc = '';
      const { userName = '', isMember = 0 } = this.profile;
        // B端
      if (isMember) {
          scriptSrc = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=bf5d4c30-2bcf-11ec-88e1-954b70961bc1&autoShow=false&language=ZHCN'
      } else {
          scriptSrc = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=4f5e7da0-2bcf-11ec-9977-830f79ef3a25&autoShow=false&language=ZHCN'
      }
      if (!document.getElementsByClassName(className).length) {
          //如果有其他类型的代码，移除之
          var otherScript = document.getElementsByClassName(otherClassName);
          if (otherScript.length) {
              otherScript[0].parentNode.removeChild(otherScript[0]);
          }
          // 设置qimoClientId
          window.qimoClientId = {
            nickName: userName,
            //是否优先进线设置，非必填，值为boolean类型的true或false
            priority: isMember === 1
          };

          //动态添加script
          var hm = document.createElement("script");
          hm.type = 'text/javascript';
          hm.className = className;
          hm.src = scriptSrc;
          hm.async = "async";
          document.body.appendChild(hm);
      }
    },
  },
};
</script>

<style lang="sass" rel="stylesheet/scss" scoped>
.entry{
  &-item{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    &-img{
      width: 20px;
      height: 20px;
    }
  }
  &-item:last-child{
    border-bottom: none;
  }
  .detail-form{
    margin-top: 0;
  }
  .upload_icon{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    span{
      font-size: 14px;
      color: #999;
    }
  }
  .qrcode{
    position: relative;
    &-img{
      position: absolute;
      top: -25px;
      left: -125px;
      width: 112px;
    }
    .qrcode-img{
      display: none;
    }
  }
  .qrcode:hover .qrcode-img{
    display: block;
  }

  .sidebar {
    position: fixed;
    bottom: 60px;
    right: 20px;
    transition: all 0.5s ease;
    // transform: translateX(100px);
    transform: translateX(0);
    background: #fff;
    padding: 0 10px;
    width: 60px;
  }

  .slideOut {
    // transform: translateX(0);
  }
}
</style>


// WEBPACK FOOTER //
// FastEntry.vue?3f04b7a5